'use strict';
const progressConfigurations = require('../models/progress-configurations'),
	_ = require('underscore'),
	mmWidgets = require('./mm-widgets'),
	progressConfigBuild = require('../models/progress-config-build');

mmWidgets.fn.progressConfigSelectorWidget = function (progressModel, options) {
	const configBuild = (options && options.configBuild) || progressConfigBuild;
	return mmWidgets.each(this, function () {
		const element = this,
			template = element.find('[data-mm-role~="selector-template"]').detach();
		element.empty();

		_.each(progressConfigurations, function (config, key) {
			const newItem = template.clone().prependTo(element);
			newItem.attr('data-mm-progress-config', key);
			newItem.find('[data-mm-role~="config-title"]').text(config.title);
			newItem.click(function () {
				const progressConfig = configBuild.apply(progressConfigBuild, config.args);
				progressModel.setStatusConfig(progressConfig);
			});

		});
	});

};
